import { useContext } from 'react';
import { ComponentContext } from '../../store/component/context';

export const useComponentConfig = () =>
  useContext(ComponentContext)?.config || {};
